<template>
  <div class="page">
    <div class="page-content">
			<div class="layoutTop"/>
      <page-nav-bar
        popoverName=""
        :subNavTitle="ServiceDetails"
        ReturnButton>
      </page-nav-bar>
      <div class="container-fluid">

        <div class="row">
          <div class="col-md-10 offset-md-1">
            <div class="panel21 panel-default">
              <div class="panel-heading">
                <h4 class="content-block labelAccordionForm">
                  <div v-if="details.direction === '0'">
                    <img src='../../../assets/static/images/icons/inbox_into.png' class="formIcon"/>
                    {{ $t('received.rcvd_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                  <div v-if="details.direction === '1'">
                    <img src='../../../assets/static/images/icons/inbox_out.png' class="formIcon"/>
                    {{ $t('sent.snt_verb_past', {itemname: $t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))}) }}
                  </div>
                </h4>
              </div>

                <div class="accordion-item accordion-item-expanded accordionForm">
                  <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                    <div class="item-inner" :class="colorBottomButton">
                      <div class="form-group row justify-content-start">
                          <div class="item-title createInvoiceBand col-sm-auto text-uppercase">
                              {{ ServiceDetails }}
                              <i class="f7-icons formChevron">chevron_right</i>
                          </div>
                      </div>
                    </div>
                  </a>

                  <div class="accordion-item-content">
                    <div class="row">
                      <form-read-group-label-input
                        :idLabel="$t('common.rsn')" :inputValue="details.remittanceInformation">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.idtfr')" :inputValue="details.endToEndId">
                      </form-read-group-label-input>
                    </div>

                    <div class="row">
                      <form-read-group-label-input
                        :idLabel="$t('common.rqst_date')" :inputValue="details.creationDate | formatDate">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.status.status_label')"
                        :inputValue="getStatusLabel(details.status, details.negotStatus)"
                        :statusIcon="getStatusIcon(details.status, details.negotStatus)">
                        <f7-button
                          class="blueBackground pain001ViewerButton"
                          @click="viewXML('pain001', details.id)"
                          v-if="details.status === '5'">
                          View Transfer Order File
                        </f7-button>
                      </form-read-group-label-input>
                    </div>

                    <div class="row"  v-if="(details.status === '0' && details.negotStatus === '0') || details.status === '7' || details.status === '8'">
                      <form-read-group-label-input
                        :idLabel="$t('common.amnt')" :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
                      </form-read-group-label-input>
                      <form-read-group-label-input
                        :idLabel="$t('common.exec_date')" :inputValue="details.requestedExecutionDate | formatDate">
                      </form-read-group-label-input>
                    </div>

                        <div
                        v-if="(details.status === '0' && details.negotStatus === '10') ||
                              (details.status === '0' && details.negotStatus === '11') ||
                              details.status === '1' ||
                              details.status === '2' ||
                              details.status === '3' ||
                              details.status === '4' ||
                              details.status === '5'">
                        <div class="transactionDetailFontSize form-group row">
                          <div class="transactionDetailSubHeader col-12">
                            Original terms
                          </div>
                        </div>

                        <div class="row">
                          <form-read-group-label-input
                            :idLabel="$t('common.orig_amount')"
                            :inputValue="details.amount + ' ' + getCurrencyIcon(details.currency)">
                          </form-read-group-label-input>
                          <form-read-group-label-input
                            :idLabel="$t('common.exec_date_orig')"
                            :inputValue="details.requestedExecutionDate | formatDate">
                          </form-read-group-label-input>
                        </div>
                      </div>

                      <div v-if="(details.status === '0' && details.negotStatus === '10') ||
                                 (details.status === '0' && details.negotStatus === '11')">
                          <div class="transactionDetailFontSize form-group row">
                            <div class="transactionDetailSubHeader col-12">
                              Negotiation
                            </div>
                          </div>

                          <div class="row">
                            <form-read-group-label-input
                              :idLabel="$t('common.new_amount')"
                              :inputValue="details.pmtNegot.amountDebtor + ' ' + getCurrencyIcon(details.ccy)">
                            </form-read-group-label-input>
                            <div class="form-group col-sm-6" v-if="details.pmtNegot.multiPayments.length > 0">
                              <label class="createInvoiceBand">
                                {{ $t('common.pymnts_annoucement', {install_number: details.pmtNegot.multiPayments.length}) }}
                              </label>
                              <table class="table table-striped table-bordered table-installment">
                                <thead class="thead-dark">
                                  <tr>
                                    <th>{{ $t('common.installment_amount') }}</th>
                                    <th>{{ $t('common.installment_date') }}</th>
                                  </tr>
                                </thead>
                                <tbody>
                                  <tr v-for="(pmt, index) in details.pmtNegot.multiPayments" :key="'pmt-' + index">
                                    <td>{{pmt.amount + ' ' + getCurrencyIcon(details.currency)}}</td>
                                    <td>{{pmt.date | formatDate }}</td>
                                  </tr>
                                </tbody>
                              </table>
                            </div>
                          </div>

                        </div>
                        <div v-if="(details.negotStatus === '12')">
                            <div class="transactionDetailFontSize form-group row">
                              <div class="transactionDetailSubHeader col-12">
                                Final Terms
                              </div>
                            </div>

                            <div class="row">
                              <form-read-group-label-input
                                :idLabel="$t('common.final_amount')"
                                :inputValue="details.pmtResp.dbtAmt !== '' ? (details.pmtResp.dbtAmt + getCurrencyIcon(details.currency)) :
                                                                             (details.amount + getCurrencyIcon(details.currency))">
                              </form-read-group-label-input>
                              <div class="form-group col-sm-6" v-if="details.pmtResp.multPmts.length > 0">
                                <label class="createInvoiceBand">
                                  {{ $t('common.pymnts_annoucement', {install_number: details.pmtResp.multPmts.length}) }}
                                </label>
                                <table class="table table-striped table-bordered table-installment">
                                  <thead class="thead-dark">
                                    <tr>
                                      <th>{{ $t('common.installment_amount') }}</th>
                                      <th>{{ $t('common.installment_date') }}</th>
                                    </tr>
                                  </thead>
                                  <tbody>
                                    <tr v-for="(pmt, index) in details.pmtResp.multPmts" :key="'pmt-' + index">
                                      <td>{{pmt.amount + ' ' + getCurrencyIcon(details.currency)}}</td>
                                      <td>{{pmt.date | formatDate }}</td>
                                    </tr>
                                  </tbody>
                                </table>
                              </div>
                            </div>
                          </div>
                      <div class="form-group row"
                          v-if="details.attachmentId !== ''"  :class="colorBottomButton">
                        <div class="col-md-3">
                          <button round
                          @click="view(details.attachmentId)"
                          class="button-action firstButtonMarginTop"
                          v-if="!ifAndroid">
                            <i class="icon fa fa-paperclip"></i>
                            View Attachment
                          </button>
                          <button round
                            v-if="ifAndroid"
                            @click="view(details.attachmentId)"
                            class="button-action firstButtonMarginTop">
                              <i class="icon fa fa-paperclip"></i>
                              Download Attachment
                          </button>
                        </div>
                      </div>
                      </div>
                    </div>
      <hr />
                        <div class="accordion-item accordionForm">
                          <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                            <div class="item-inner" :class="colorBottomButton">
                              <div class="form-group row justify-content-start">
                                  <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '0'">
                                    SENDER INFORMATION
                                    <i class="f7-icons formChevron">chevron_right</i>
                                  </div>
                                  <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '1'">
                                    MY ACCOUNT INFORMATION
                                    <i class="f7-icons formChevron">chevron_right</i>
                                  </div>
                              </div>
                            </div>
                          </a>

                          <div class="accordion-item-content">

                            <div class="row">
                              <form-read-group-label-input
                                :idLabel="$t('common.nme')"
                                :inputValue="details.creditorName">
                              </form-read-group-label-input>
                              <form-read-group-label-input
                                :idLabel="$t('common.idtfr')"
                                :inputValue="details.creditorIdentifier">
                              </form-read-group-label-input>
                            </div>

                            <div class="row">
                              <form-read-group-label-input
                                :idLabel="$t('bank_accounts.bank_account_singular')"
                                :inputValue="hideIban(details.creditorBankAccount)">
                              </form-read-group-label-input>
                            </div>
                          </div>
                        </div>
                    <hr />
                          <div class="accordion-item accordionForm">
                            <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                              <div class="item-inner" :class="colorBottomButton">
                                <div class="form-group row justify-content-start">
                                    <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '0'">
                                      MY ACCOUNT INFORMATION
                                      <i class="f7-icons formChevron">chevron_right</i>
                                    </div>
                                    <div class="item-title createInvoiceBand col-sm-auto" v-if="details.direction === '1'">
                                      SENDER INFORMATION
                                      <i class="f7-icons formChevron">chevron_right</i>
                                    </div>
                                </div>
                              </div>
                            </a>

                            <div class="accordion-item-content">
                              <div class="row">
                                <form-read-group-label-input
                                  :idLabel="$t('common.nme')"
                                  :inputValue="details.debtorName">
                                </form-read-group-label-input>
                                <form-read-group-label-input
                                  :idLabel="$t('common.idtfr')"
                                  :inputValue="details.debtorIdentifier">
                                </form-read-group-label-input>
                              </div>

                              <div class="row justify-content-start">
                                <div class="form-group col-sm-6">
                                  <label class="createInvoiceBandlabelAccordionForm">
                                    Bank account
                                  </label>
                                  <div class="labelAccordionForm" v-if="(details.direction === '1' && paymentMethod === 'application') ||
                                                                        (details.direction === '0' &&
                                                                          (details.status === '4' || details.status === '1'))">
                                    <input v-if="details.debtorBankAccount.length > 0" type="text"
                                          disabled='true' class="form-control inputAccordionForm"
                                          :value="hideIban(details.debtorBankAccount)" ></input>
                                    <span v-if="details.debtorBankAccount.length === 0">Not specified</span>
                                  </div>
                                  <div class="labelAccordionForm" v-if="details.direction === '0' && details.status === '0' && paymentMethod === 'application'">
                                    <input type="text"
                                    class="form-control inputAccordionForm"
                                    v-bind:class="{redBackground: bankAccountSelectDebit === ''}"
                                    v-model="bankAccountSelectDebit"
                                    @focus="showBankAccountSelectionList($event)"
                                    >
                                    <!-- @focus="showBankAccountSelectionList($event)" -->
                                    <!-- IRY 17/02/2020
                                      Remise en service du selecteur de compte bancaire IBAN (côté receiver de RTP)
                                    -->
                                    <div class="col-12 bankAccountDebitSelectionListContainer"  ref="ibanBox" v-if="showIbanBox">
                                      <div class="closeSelectionListContainerLabel" @click="closeSelectionListContainer">
                                        <div class="closeSelectionListContainerLabelName">
                                          Bank account list
                                        </div>
                                        <f7-button class="button-round orangeBackground rightButton" style="padding:0px 3px;">
                                          Close
                                        </f7-button>
                                      </div>
                                      <ul class="bankAccountDebitSelectionList">
                                        <li v-if="bankAccounts.length > 0"
                                        class="bankAccountDebitSelectionListItem"
                                        @click="selectBankAccount($event)"
                                        v-for="bankAccount in bankAccounts"
                                        :data-iban="bankAccount.iban">
                                          <div>{{ bankAccount.iban }}</div>
                                          <div>{{ bankAccount.name }}</div>
                                        </li>
                                        <li v-else
                                        class="bankAccountDebitSelectionListItem">
                                          <div style="text-align: center;">No bank account</div>
                                        </li>
                                      </ul>
                                    </div>
                                  </div>
                                </div>
                              </div>
                            </div>
                          </div>
                        </ul>
                      <hr />
                    <div class="accordion-item accordionForm">
                      <a href="#" class="item-content item-link" @click="rotateChevron($event)">
                        <div class="item-inner" :class="colorBottomButton">
                          <div class="form-group row justify-content-start">
                              <div class="item-title createInvoiceBand col-sm-auto">
                                  REQUEST TO PAY HISTORY
                                  <i class="f7-icons formChevron">chevron_right</i>
                              </div>
                          </div>
                        </div>
                      </a>

                      <div class="accordion-item-content" v-if="details.history.length > 0">
                        <div class="form-group row">
                          <div class="col-12">

                            <table class="table table-striped table-bordered table-status-history">
                              <thead class="thead-dark">
                                <tr>
                                  <th scope="col" class='reponsiveColumnWidth'>Date</th>
                                  <th scope="col">Status</th>
                                </tr>
                              </thead>
                              <tbody>
                                <tr class="transactionDetailFontSize" v-for="record in details.history" :key="record.id">
                                  <td class="dateTimehistoryHeight">{{record.creationDate | formatDateTime}}</td>
                                  <td>
                                    <span>{{getHistoryLabel(record.status)}} <i :class="'icon icon-transaction-detail ' + getHistoryIcon(record.status)"></i></span>
                                    <div class="item-content" v-if="(record.status==='10' || record.status==='11') && record.comment!==''">
                                      <div class="item-inner" style="display:block;">
                                        <div class="item-title-row" style="font-style:italic;">
                                          Negotiation Comment:
                                        </div>
                                        <div class="item-title-row">
                                          <div style="color:#8e8e93">{{record.comment}}</div>
                                        </div>
                                      </div>
                                    </div>
                                    <div class="transactionDetailFontSize">
                                      <li class="item-content" v-if="(details.status==='1' || details.status==='2' || details.status==='3') && details.responseComment !== ''">
                                        <div class="item-inner" style="display:block;">
                                          <div class="item-title-row">
                                            Response Comment:
                                          </div>
                                          <div class="item-title-row">
                                            <div style="color:#8e8e93">{{details.responseComment}}</div>
                                          </div>
                                        </div>
                                      </li>
                                    </div>
                                  </td>
                                  </tr>
                                </tbody>
                              </table>
                          </div>
                        </div>
                      </div>
                    </div>
              </div>
            </div>
          </div>


  <!-- Détails d'une demande pour la boîte de réception -->
<div v-if="details.direction === '0' && details.status === '0'" class="inboxDetailButton" :class="colorBottomButton">
    <div class="row justify-content-start">
      <div class="col-md-3 offset-md-1">
        <button round
        class="button-action firstButtonMarginTop"
        @click="bankCardAccept($event)"
        v-if="(details.pymtModAcpt === 'true' && details.negotStatus !== '11' && details.negotStatus !== '10' && paymentMethod === 'bankCard') ||
              (details.pymtModAcpt === 'false' && paymentMethod === 'bankCard')">
          <i class="icon fa fa-check"></i>
					Accept
				</button>
				<button round
        class="button-action firstButtonMarginTop"
        @click="transactionAccepted()"
        v-if="(details.pymtModAcpt === 'true' && details.negotStatus !== '11' && details.negotStatus !== '10' && paymentMethod === 'application') ||
              (details.pymtModAcpt === 'false' && paymentMethod === 'application')">
          <i class="icon fa fa-check"></i>
					Accept
				</button>
        <button round
        class="button-action firstButtonMarginTop"
        v-if="details.pymtModAcpt === 'true' && details.negotStatus === '11'"
        @click="confirmNegotiation">
          <i class="icon fa fa-check"></i>
          Accept
        </button>
      </div>

      <div class="col-md-4">
        <a href="/payments/negotiate/">
          <button round
          class="button-action firstButtonMarginTop"
          v-if="details.pymtModAcpt === 'true' && details.negotStatus === '0'"
          >
          <i class="icon fa fa-repeat"></i>
            Send Negotiation Request
          </button>
        </a>
      </div>

      <div class="col-md-3">
        <button round
        class="button-action firstButtonMarginTop"
        v-if="details.negotStatus !== '10'"
        @click="transactionRefused">
          <i class="icon fa fa-hand-stop-o"></i>
          Refuse
        </button>
      </div>
    </div>
  </div>



  <!-- Détails pour une demande envoyée -->
  <div v-if="details.direction === '1'" :class="colorBottomButton">
    <div class="row justify-content-start" v-if="details.status === '0' && details.negotStatus === '10' && details.pymtModAcpt === 'true'">
      <div class="col-md-3 offset-md-1">
        <button round
        class="button-action firstButtonMarginTop" @click="acceptNegotiation()">
        <i class="icon fa fa-handshake-o"></i>
          Accept Negotiation
        </button>
      </div>

      <div class="col-md-4">
        <a href="/payments/negotiate/">
          <button round
          class="button-action firstButtonMarginTop">
          <i class="icon fa fa-repeat"></i>
            Negotiate
          </button>
        </a>
      </div>

      <div class="col-md-3">
        <button round
        class="button-action firstButtonMarginTop" @click="refuseNegotiation()">
          <i class="icon fa fa-hand-stop-o"></i>
          Refuse and insist on the original request
        </button>
      </div>
    </div>

    <div class="row justify-content-start">
      <div class="col-md-3 offset-md-8">
        <button round
          v-if="(details.status === '0' && details.negotStatus === '11') ||
                (details.status === '0' && details.negotStatus === '0')"
          class="button-action firstButtonMarginTop"
          @click="remindReceiver(details.id)">
          <i class="icon fa fa-bell"></i>
          Remind receiver
        </button>
      </div>
    </div>
  </div>
    </div>

      <div class="layoutBottom"></div>
      <div class="toolbarPageBottomBlank"></div>
    </div>
  </div>
</div>
</template>

<script>
import b64toBlob from 'b64-to-blob'
import moment from 'moment'
import pageNavBar from '@/components/common/pageNavBar.vue'
import bottomToolbar from '@/components/bottomToolbar/bottomToolbar.vue'
import {errorMessageAlert} from '@/helpers/alert'
import {loadPage} from '@/helpers/routing'
import formReadGroupLabelInput from '@/components/common/formReadGroupLabelInput.vue'
import {statusLabel, statusIcon, statusColor, statusLabelHistory, statusIconHistory} from '@/helpers/labels'
import crypto from 'crypto'
import * as resizer from 'iframe-resizer'
import {formatIbanHidden} from '@/helpers/format'

export default {
  name: 'transaction-details',
  components: {
    'page-nav-bar': pageNavBar,
    'bottom-toolbar': bottomToolbar,
    'form-read-group-label-input': formReadGroupLabelInput
  },
  data () {
    return {
      action: '',
      label: '',
      multPmts: [],
      ImmPmtAccepted: '',
      bankAccountSelectDebit: '',
      paymentMethod: '',
      ifr: resizer,
      attachement: '',
      attachementName: '',
      attachementReference: '',
      attachementId: '',
      cloudFiles: [],
      cloudDocsPicker: '',
      showIbanBox: false,
      colorBottomButton: this.$engine.services.getButtonClassColorById(this.$engine.user.currentService.id),
      ServiceDetails: ''
    }
  },
  beforeCreate () {
    this.Dom7('iframe').remove()
  },
  created () {
    this.ServiceDetails = this.$i18n.t('common.item_details',
      {itemname: this.$i18n.t(this.$engine.services.getSingularNameFromServiceId(this.$engine.user.currentService.id))})
    let that = this
    this.$f7.params.swipePanel = that.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = that.$engine.services.directPayments.filter.smartphoneStorage
    this.$bus.emit('service:change', 'Payments')
    this.$bus.$off('refresh-cache-bank-accounts')
    this.$bus.$off('refresh-cache-contacts')
    this.$bus.$off('refresh-cache-attachments')
    this.$bus.$off('refresh-cache-account-members')
    if (this.details.dbBkAcct !== '') {
      this.bankAccountSelectDebit = this.details.debtorBankAccount
    } else {
      if (this.$engine.bankAccounts.getDefaultBankAccount().iban !== undefined) {
        this.bankAccountSelectDebit = this.$engine.bankAccounts.getDefaultBankAccount().iban
      } else {
        this.bankAccountSelectDebit = ''
      }
    }
    this.paymentMethod = this.$engine.settings.get().paymentMethod
    this.cloudFiles = this.$engine.attachments.get()
    let filesMap = this.cloudFiles.map(function (obj) {
      let rObj = {}
      rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
      return rObj
    })
    let filesMapObj = Object.assign({}, ...filesMap)
    let values = []
    if (Object.keys(filesMapObj).length > 0) {
      values = Object.keys(filesMapObj)
    } else {
      values = ['Nothing found']
    }
    this.cloudDocsPicker = this.$f7.picker({
      input: '#application-file-input',
      rotateEffect: true,
      cols: [
        {
          textAlign: 'center',
          values: values
        }
      ],
      onClose: function (p) {
        if (Object.keys(filesMapObj).length > 0) {
          if (filesMapObj[p.value].id !== that.attachementId) {
            that.attachementId = filesMapObj[p.value].id
            that.cloudFileSel()
          }
        }
      },
      onOpen: function (p) {
        if (Object.keys(filesMapObj).length > 0) {
          that.attachementName = p.value
        }
      }
    })
  },
  mounted () {
    /* TLV 23/06/2020
    * Sur tous les écrans, les accordéons sont étendus par défaut
    */
    this.$$('.accordionForm').addClass('accordion-item-expanded')
    this.$$('.formChevron').transform('rotate(90deg)')
  },
  beforeDestroy () {
    this.$f7.params.swipePanel = this.$engine.services.directPayments.filter.smartphoneStorage ? 'left' : false
    this.$f7.params.panelsCloseByOutside = this.$engine.services.directPayments.filter.smartphoneStorage
    this.attachementName = ''
    this.attachment = ''
    this.attachementReference = ''
    this.cloudDocsPicker = ''
    this.cloudFiles = []
  },
  computed: {
    attachementNameLabel () {
      if (this.attachementName === '') {
        return 'Select or Create'
      } else {
        return this.attachementName
      }
    },
    details: function () {
      return this.$settings.clickedMessage
    },
    isInbox: function () {
      return this.$settings.msgFromInbox
    },
    paymentsResp: function () {
      return this.$settings.clickedMessage.pmtResp
    },
    bankAccounts: function () {
      return this.$engine.bankAccounts.get()
    },
    ifAndroid: function () {
      if (this.$f7.device.os === 'android') {
        return true
      } else {
        return false
      }
    }
  },
  methods: {
    onFileChange (e) {
      var files = e.target.files || e.dataTransfer.files
      if (!files.length) { return }
      if (files[0].size <= 500000) {
        this.createImage(files[0])
        this.attachementName = files[0].name
        this.Dom7(this.Dom7('.fileNameDisplay')[this.Dom7('.fileNameDisplay').length - 1]).text(this.attachementName)
      } else {
        this.$f7.alert('This file has a size of ' + Math.round(files[0].size / 1000) + 'Kb. \n Maximum permited is 500Kb', 'Maximum file size exceeded')
      }
    },
    createImage (file) {
      var that = this
      var reader = new FileReader()
      reader.onload = (e) => {
        that.attachement = e.target.result
      }
      reader.readAsDataURL(file)
    },
    hideBlock ($event) {
      let that = this
      if (that.Dom7($event.target).hasClass('card-header')) {
        if (that.Dom7($event.target).next().css('display') === 'none') {
          that.Dom7($event.target).next().show()
          that.Dom7($event.target).find('i').transform('rotate(0deg)')
        } else {
          that.Dom7($event.target).next().hide()
          that.Dom7($event.target).find('i').transform('rotate(-90deg)')
        }
      } else {
        if (that.Dom7($event.target).parent().next().css('display') === 'none') {
          that.Dom7($event.target).parent().next().show()
          that.Dom7($event.target).parent().find('i').transform('rotate(0deg)')
        } else {
          that.Dom7($event.target).parent().next().hide()
          that.Dom7($event.target).parent().find('i').transform('rotate(-90deg)')
        }
      }
      // that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top - that.$$('.page-content').offset().top + that.$$('.page-content').scrollTop() + 300, 400)
      that.$$('.page-content').scrollTop(that.Dom7($event.target).offset().top + that.$$(that.$$('.page-content')[that.$$('.page-content').length - 1]).offset().top - 96, 400)
    },
    download (id) {
      /* eslint-disable no-undef */
      const that = this
      this.$f7.showPreloader('Downloading File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          that.writeToFile(
            response.data.documentName,
            response.data.documentData,
            response.data.documentData.split(';')[0].replace(/^data:/, ''),
            false,
            function (filePath, fileType) {
              that.$f7.alert(filePath.split('/')[filePath.split('/').length - 1], 'Following file successfully saved.')
            },
            function () {
              that.$f7.alert('', 'Error creating the file')
            }
          )
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
        })
      /* eslint-enable no-undef */
    },
    rotateChevron ($event) {
      if (this.Dom7($event.target).parent().parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().parent().hasClass('accordion-item-expanded') ||
          this.Dom7($event.target).parent().hasClass('accordion-item-expanded')) {
        this.Dom7($event.target).find('i').transform('rotate(0deg)')
      } else {
        this.Dom7($event.target).find('i').transform('rotate(90deg)')
      }
    },
    view: function (id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getAttachmentDetail(id)
        .then(response => {
          this.$engine.settings.set({Attachment: {
            data: response.data.documentData,
            name: response.data.documentName,
            mimeType: response.data.documentData.split(';')[0].replace(/^data:/, ''),
            id: id
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              response.data.documentName,
              response.data.documentData,
              response.data.documentData.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { // browser
            let blob = b64toBlob(response.data.documentData.split(',')[1], response.data.documentData.split(';')[0].replace(/^data:/, ''))
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            fileLink.setAttribute('download', response.data.documentName) // or any other extension
            fileLink.click()
          }
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
          setTimeout(function () { that.$f7.hidePreloader() }, 1000)
        })
        .catch(error => {
          that.$f7.hidePreloader()
          errorMessageAlert(error, that)
          // errorMessageAlert(error, that)
        })
    },
    viewXML: function (type, id) {
      // Get cloudDocument
      // var resource = 'attachment/detail/' + id
      let service = 'payment'
      const that = this
      this.$f7.showPreloader('Opening File')
      this.$engine.services.payments.getXMLDetail(service, type, id)
        .then(response => {
          that.$f7.hidePreloader()
          this.$engine.settings.set({type: {
            data: response.data.data
          }})
          if (that.$f7.device.os === 'android' || that.$f7.device.os === 'ios') {
            that.writeToFile(
              service + '_' + type + '_' + id + '.xml',
              response.data.data,
              response.data.data.split(';')[0].replace(/^data:/, ''),
              true,
              function (filePath, fileType, fileName) {
                that.readFile(filePath, fileType, fileName)
              },
              function () {
                that.$f7.alert('', 'Error creating the file')
              }
            )
          } else { // browser
            let blob = b64toBlob(response.data.data.split(',')[1], 'text/xml')
            const url = window.URL.createObjectURL(blob)
            const fileLink = document.createElement('a')
            fileLink.href = url
            let today = moment().format()
            fileLink.setAttribute('download', 'Transfer_Order_' + today) // or any other extension
            fileLink.click()
          }
        })
        .catch(error => {
          that.$f7.hidePreloader()
          console.log(error)
          // errorMessageAlert(error, that)
        })
    },
    writeToFile (fileName, data, fileType, readonly, success, error) {
      /* eslint-disable no-undef */
      let that = this
      let directory = ''

      if (readonly) {
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalDataDirectory
        } else if (that.$f7.device.os === 'ios') {
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        that.saveFileToDirectory(fileName, data, fileType, directory, success, error)
      } else {
        // directory = cordova.file.externalRootDirectory
        if (that.$f7.device.os === 'android') {
          directory = cordova.file.externalRootDirectory
        } else if (that.$f7.device.os === 'ios') {
          // directory = cordova.file.dataDirectory
          directory = cordova.file.tempDirectory
        } else {
          directory = cordova.file.dataDirectory
        }
        try {
          that.checkForWritePermissions(function () {
            try {
              window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
                directoryEntry.getDirectory('Download', {create: true}, function (downloadDir, _data) {
                  that.saveFileToDirectory(fileName, data, fileType, downloadDir.nativeURL, function (filePath, fileType) {
                    console.log('sucess saving file: ', filePath)
                  }, function (error, _data) {
                    console.error('error on saving file' + error.code)
                    alert('Unable to save file: ' + error.code)
                  })
                }, function (error, _data) {
                  console.error('error on accessing download directory' + error.code)
                  alert('Unable to get/create download directory: ' + error.code)
                })
              }, (e, file) => { // error resolveLocalFileSystemURL
              })
            } catch (error) { // get dir
              console.error(error)
            }
          }, function () {
            alert('App needs access to the phone\'s file storage in order to save files.')
          })
        } catch (error) { // get perms
          console.error(error)
        }
      }
      /* eslint-enable no-undef */
    },
    checkForWritePermissions (sucess, error) {
      /* eslint-disable no-undef */
      if (this.$f7.device.os === 'android') {
        cordova.plugins.diagnostic.requestRuntimePermission(function (status) {
          switch (status) {
            case cordova.plugins.diagnostic.permissionStatus.GRANTED:
              console.log('Permission granted')
              sucess()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED:
              console.log('Permission denied')
              error()
              break
            case cordova.plugins.diagnostic.permissionStatus.DENIED_ALWAYS:
              console.log('Permission permanently denied')
              error()
              break
          }
        }, function (error) {
          console.error('The following error occurred: ' + error)
        },
          cordova.plugins.diagnostic.permission.WRITE_EXTERNAL_STORAGE
        )
      } else if (this.$f7.device.os === 'ios') {
        sucess()
      }
      /* eslint-enable no-undef */
    },
    saveFileToDirectory (fileName, data, fileType, directory, success, error) {
      /* eslint-disable no-undef */
      let directoryEntryReference = null
      window.resolveLocalFileSystemURL(directory, function (directoryEntry) {
        directoryEntryReference = directoryEntry
        directoryEntry.getFile(fileName, { create: true, exclusive: true }, function (fileEntry) {
          fileEntry.createWriter(function (fileWriter) {
            fileWriter.onwriteend = function (e) {
              success(e.target.localURL, fileType, fileName)
            }
            fileWriter.onerror = function (e) {
              error()
            }
            let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
            fileWriter.write(blob)
          }, (e, file) => {
          })
        }, (e, file) => {
          navigator.notification.confirm('This file already exists do you want to override it ? (' + fileName + ')', function (index) {
            console.log('Do you want to override the following file: ' + fileName + ' (' + index + ')')
            switch (index) {
              case 1: // No
                console.log('No. Returning to idle state.')
                break
              case 2: // Yes -> overrides  the file
                console.log('Yes. Overriding file.')
                directoryEntryReference.getFile(fileName, { create: true, exclusive: false }, function (fileEntry) {
                  fileEntry.createWriter(function (fileWriter) {
                    fileWriter.onwriteend = function (e) {
                      success(e.target.localURL, fileType, fileName)
                    }
                    fileWriter.onerror = function (e) {
                      error()
                    }
                    let blob = b64toBlob(data.replace(/^data:\w+\/\w+;base64,/, ''), fileType)
                    fileWriter.write(blob)
                  }, (e, file) => {
                  })
                }, (e, file) => {
                })
                break
            }
          }, 'Information', ['No', 'Yes'])
        })
      }, (e, file) => { // error resolveLocalFileSystemURL
      })
      /* eslint-enable no-undef */
    },
    readFile (filePath, fileType, fileName) {
      /* eslint-disable no-undef */
      // TODO : test fileType before trying to open and let the user know
      window.resolveLocalFileSystemURL(filePath, function (entry) {
        cordova.plugins.fileOpener2.open(entry.nativeURL.replace(/%20/g, ' '), fileType, {
          error: function (e) {
            // TODO : screen user stuff
          },
          success: function (s) {
            // TODO : screen user stuff
          }
        })
      })
    },
    returnBack () {
      this.$f7.mainView.router.back()
    },
    getPaymentsExec (typeExec, limitDate) {
      if (typeExec === 'IMMED') {
        return 'Immediate'
      } else {
        return limitDate
      }
    },
    getCurrencyIcon (ccy) {
      switch (ccy) {
        case 'EUR':
          return '€'
        case 'USD':
          return '$'
        case 'GBP':
          return '£'
        case 'JPY':
          return '¥'
        case 'RUB':
          return '₽'
        default:
          return ccy
      }
    },
    getStatusLabel (status, negotStatus) {
      return statusLabel(this.$i18n, status, negotStatus)
    },
    getStatusIcon (status, negotStatus) {
      return statusIcon(status, negotStatus)
    },
    getStatusColor (status, negotStatus) {
      return statusColor(status, negotStatus)
    },
    getHistoryLabel (status) {
      return statusLabelHistory(this.$i18n, status)
    },
    getHistoryIcon (status) {
      return statusIconHistory(status)
    },
    confirmNegotiation () {
      let that = this
      if (that.bankAccountSelectDebit.length === 0) {
        this.$f7.alert('', 'Bank account missing')
        return
      }
      if (parseFloat(this.$engine.settings.get().validationThreshold) > parseFloat(this.details.amt)) {
        let status = '2'
        if (that.$settings.clickedMessage.amt === that.details.pmtNegot.amountDebtor &&
        that.$settings.clickedMessage.reqstdExecDt === that.details.pmtNegot.debtorPaymentsDate) {
          status = '1'
        }
        let debtorBankAccountToSend = that.bankAccountSelectDebit
        // debtorBankAccountToSend = that.bankAccountSelectDebit
        that.$engine.services.payments.answerToPayments(
          that.$settings.clickedMessage.id,
          status,
          Number.parseFloat(that.details.pmtNegot.amountDebtor),
          that.details.pmtNegot.debtorPaymentsDate,
          '',
          debtorBankAccountToSend,
          that.$engine.settings.get().isToGenerateXML,
          that.details.pmtNegot.immediatePayments === 'true',
          that.details.pmtNegot.multiPayments
        ).then(response => {
          loadPage(that, {url: '/payments/inbox/'})
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        this.$f7.modal({
          title: 'Confirm Transaction',
          text: 'Comment (optional, 255 chars maximum)',
          afterText: '<div class="item-input"><textarea class="confirmNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                let status = '2'
                if (that.$settings.clickedMessage.amt === that.details.pmtNegot.amountDebtor &&
                that.$settings.clickedMessage.reqstdExecDt === that.details.pmtNegot.debtorPaymentsDate) {
                  status = '1'
                }
                let debtorBankAccountToSend = ''
                // if (that.details.dbBkAcct === '') {
                debtorBankAccountToSend = that.bankAccountSelectDebit
                // }
                that.$engine.services.payments.answerToPayments(
                  that.$settings.clickedMessage.id,
                  status,
                  Number.parseFloat(that.details.pmtNegot.amountDebtor),
                  that.details.pmtNegot.debtorPaymentsDate,
                  that.Dom7('.confirmNegotiation').val(),
                  debtorBankAccountToSend,
                  that.$engine.settings.get().isToGenerateXML,
                  that.details.pmtNegot.immediatePayments === 'true',
                  that.details.pmtNegot.multiPayments
                ).then(response => {
                  loadPage(that, {url: '/payments/inbox/'})
                })
                .catch(error => {
                  errorMessageAlert(error, that)
                })
              }
            }
          ]
        })
      }
    },
    transactionAccepted () {
      let that = this
      if (that.bankAccountSelectDebit.length === 0) {
        this.$f7.alert('', 'Bank account missing')
        return
      }

      let bankAccountIbans = []
      for (let i = 0; i < that.bankAccounts.length; i++) {
        bankAccountIbans.push(that.bankAccounts[i].iban)
      }
      if (!bankAccountIbans.includes(that.bankAccountSelectDebit)) {
        that.$f7.modal({
          title: 'Bank account doesn\'t exist',
          text: 'This IBAN is not saved. Do you want to save this IBAN?',
          buttons: [
            {
              text: 'Save',
              onClick: function () {
                that.$engine.bankAccounts
                .create({name: 'Account_' + Math.random().toString(36).substring(7), iban: that.bankAccountSelectDebit})
                .then(resp => {
                  that.$bus.$emit('refresh-cache-bank-accounts')
                  that.confirmModal()
                })
                .catch(err => {
                  errorMessageAlert(err, that)
                })
              }
            },
            {
              text: 'Cancel',
              onClick: function () {
              }
            }
          ]
        })
      } else {
        this.confirmModal()
      }
    },
    confirmModal () {
      let that = this
      if (parseFloat(this.$engine.settings.get().validationThreshold) > parseFloat(this.details.amt)) {
        that.action = 'accept'
        that.ImmPmtAccepted = 'true'
        that.answerToPayments('1', {comment: '', isToGenerateXML: that.$engine.settings.get().isToGenerateXML})
      } else {
        this.$f7.modal({
          title: 'Confirm Transaction',
          text: 'Comment (optional, 255 chars maximum)',
          afterText: '<div class="item-input"><textarea class="acceptComment commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function ($event) {
                that.action = 'accept'
                that.ImmPmtAccepted = 'true'
                that.answerToPayments('1', {comment: that.Dom7('.acceptComment').val(), isToGenerateXML: that.$engine.settings.get().isToGenerateXML})
              }
            }
          ]
        })
      }
    },
    refuseNegotiation () {
      let that = this
      if (parseFloat(this.$engine.settings.get().validationThreshold) > parseFloat(this.details.amt)) {
        that.$engine.services.payments.negotiatePayments(
          that.$settings.clickedMessage.id,
          'negotResp',
          'KO',
          Number(that.$settings.clickedMessage.amt),
          false,
          that.$settings.clickedMessage.reqstdExecDt,
          ''
        ).then(response => {
          if (response.status === 200) {
            that.$f7.alert('', 'Negotiation Refused', function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/'})
            })
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$f7.modal({
          title: 'Refuse Negotiation',
          text: 'Comment (optional, 255 chars maximum)',
          afterText: '<div class="item-input"><textarea class="refuseNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                that.$engine.services.payments.negotiatePayments(
                  that.$settings.clickedMessage.id,
                  'negotResp',
                  'KO',
                  Number(that.$settings.clickedMessage.amt),
                  false,
                  that.$settings.clickedMessage.reqstdExecDt,
                  that.Dom7('.refuseNegotiation').val()
                ).then(response => {
                  if (response.status === 200) {
                    that.$f7.alert('', 'Negotiation Refused', function () {
                      that.$f7.closeModal()
                      loadPage(that, {url: '/payments/sendbox/'})
                    })
                  }
                }).catch(error => {
                  errorMessageAlert(error, that)
                })
              }
            }
          ]
        })
      }
    },
    acceptNegotiation () {
      let that = this
      if (parseFloat(this.$engine.settings.get().validationThreshold) > parseFloat(this.details.amt)) {
        that.$engine.services.payments.negotiatePayments(
          that.$settings.clickedMessage.id,
          'negotResp',
          'OK',
          Number(that.details.pmtNegot.amountDebtor),
          false,
          that.details.pmtNegot.debtorPaymentsDate,
          '',
          that.details.pmtNegot.multiPayments
        ).then(response => {
          if (response.status === 200) {
            that.$f7.alert('', 'Negotiation Accepted', function () {
              that.$f7.closeModal()
              loadPage(that, {url: '/payments/sendbox/'})
            })
          }
        }).catch(error => {
          errorMessageAlert(error, that)
        })
      } else {
        that.$f7.modal({
          title: 'Confirm Negotiation',
          text: 'Comment (optional, 255 chars maximum)',
          afterText: '<div class="item-input"><textarea class="acceptNegotiation commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                that.$engine.services.payments.negotiatePayments(
                  that.$settings.clickedMessage.id,
                  'negotResp',
                  'OK',
                  Number(that.details.pmtNegot.amountDebtor),
                  false,
                  that.details.pmtNegot.debtorPaymentsDate,
                  that.Dom7('.acceptNegotiation').val(),
                  that.details.pmtNegot.multiPayments
                ).then(response => {
                  if (response.status === 200) {
                    that.$f7.alert('', 'Negotiation Accepted', function () {
                      that.$f7.closeModal()
                      loadPage(that, {url: '/payments/sendbox/'})
                    })
                  }
                }).catch(error => {
                  errorMessageAlert(error, that)
                })
              }
            }
          ]
        })
      }
    },
    transactionRefused () {
      let that = this
      if (parseFloat(this.$engine.settings.get().validationThreshold) > parseFloat(this.details.amt)) {
        that.action = 'refuse'
        that.ImmPmtAccepted = 'true'
        that.answerToPayments('3', {comment: '', isToGenerateXML: that.$engine.settings.get().isToGenerateXML})
      } else {
        this.$f7.modal({
          title: 'Revoke Transaction',
          text: '<p>Are you sure to refuse this transaction?</p><p>Comment (optional, 255 chars maximum)</p>',
          afterText: '<div class="item-input"><textarea class="refuseComment commentTextArea"></textarea></div>',
          buttons: [
            {
              text: 'Cancel',
              onClick: function () {
              }
            },
            {
              text: 'Ok',
              onClick: function () {
                that.action = 'refuse'
                that.ImmPmtAccepted = 'true'
                that.answerToPayments('3', {comment: that.Dom7('.refuseComment').val(), isToGenerateXML: that.$engine.settings.get().isToGenerateXML})
              }
            }
          ]
        })
      }
    },
    closeModal (hidden) {
      const that = this
      that.$f7.closeModal()
      /* when we use modify button, panel was displayed on the page, in front of user's actions */
      if (hidden) {
        document.getElementById('modif-actions').style.display = 'none'
      }
    },
    linkInvoiceToTransaction () { // #find
      let that = this
      that.$engine.attachments.linkDocumentToPayments(this.details.id, that.attachementName, that.attachement, that.attachementReference)
        .then(response => {
          if (response.status === 200) {
            that.$f7.alert('The invoice has been linked to the transaction.', 'Invoice linked')
            that.$settings.clickedMessage.hasAttachment = '1'
            that.$settings.clickedMessage.idAttachment = that.attachementId
          }
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    cloudFileSel () {
      const that = this
      this.loadingFile = true
      this.$engine.attachments.download(that.attachementId.toString())
        .then(response => {
          that.attachementName = response.data.document_name
          that.attachement = response.data.document_data
          that.loadingFile = false
          that.attachementReference = response.data.internal_reference
          that.Dom7(that.Dom7('.fileNameDisplay')[that.Dom7('.fileNameDisplay').length - 1]).text(that.attachementName)
        })
        .catch(error => {
          errorMessageAlert(error, that)
        })
    },
    filesPicker (e) {
      e.stopPropagation()
      // if (this.loadingFile === true || !this.fromCloud) { return }
      this.cloudDocsPicker.open()
    },
    openImportAttachmentInvoice () {
      let that = this
      let buttons1 = [
        {
          text: 'Import from device',
          onClick: function () {
            that.attachement = ''
            that.attachementName = ''
            that.attachementReference = ''
            that.attachementId = ''
            that.Dom7(that.Dom7('.local-file-input')[that.Dom7('.local-file-input').length - 1]).click()
          }
        },
        {
          text: 'Import from MoneyRoad',
          onClick: function (event, event2) {
            that.attachement = ''
            that.attachementName = ''
            that.attachementReference = ''
            that.attachementId = ''
            that.filesPicker(event2)
          }
        }
        // ,
        // {
        //   text: 'Get related invoices',
        //   onClick: function (event, event2) {
        //     that.$engine.attachments.getRecommendedList(that.amount, '', that.attachementReference, that.executionDate)
        //     .then(response => {
        //       let filesMap = response.data['recommendationList'].map(function (obj) {
        //         let rObj = {}
        //         rObj[obj.name] = {id: obj.id, name: obj.name, type: obj.type, internalReference: obj.internalReference}
        //         return rObj
        //       })
        //       let filesMapObj = Object.assign({}, ...filesMap)
        //       let values = []
        //       if (Object.keys(filesMapObj).length > 0) {
        //         values = Object.keys(filesMapObj)
        //       } else {
        //         values = ['Nothing found']
        //       }
        //       let recommendationListPicker = that.$f7.picker({
        //         input: '#recommendation-list-input',
        //         rotateEffect: true,
        //         cols: [
        //           {
        //             textAlign: 'center',
        //             values: values
        //           }
        //         ],
        //         onClose: function (p) {
        //           if (Object.keys(filesMapObj).length > 0) {
        //             if (filesMapObj[p.value].id !== that.attachementId) {
        //               that.attachementId = filesMapObj[p.value].id
        //               that.cloudFileSel()
        //             }
        //           }
        //         },
        //         onOpen: function (p) {
        //           if (Object.keys(filesMapObj).length > 0) {
        //             that.attachementName = p.value
        //           }
        //         }
        //       })
        //       recommendationListPicker.open()
        //     })
        //     .catch(error => {
        //       errorMessageAlert(error, that)
        //     })
        //   }
        // }
      ]
      let buttons2 = [
        {
          text: 'Cancel',
          color: 'red',
          onClick: function () {
          }
        }
      ]
      this.$f7.actions([buttons1, buttons2])
    },
    answerToPayments: function (status, optionals = {ImmPmtAc: 'false', comment: '', isToGenerateXML: '1'}) {
      let today = moment().format('YYYY-MM-DD')
      let execDate = optionals.ImmPmtAc === 'true' ? today : this.$settings.clickedMessage.reqstdExecDt
      const that = this
      let debtorBankAccountToSend = ''
      // if (that.details.dbBkAcct === '') {
      debtorBankAccountToSend = that.bankAccountSelectDebit
      let amount = this.$settings.clickedMessage.amt !== '' ? this.$settings.clickedMessage.amt : this.details.amt

      // }
      let multiplePaymentsToSend = []
      if (that.details.pmtNegot !== undefined && that.details.pmtNegot.multiPayments.length > 0 && that.details.pmtNegot.multiPayments !== undefined) {
        multiplePaymentsToSend = that.details.pmtNegot.multiPayments
      }
      that.$engine.services.payments.answerToPayments(
        that.$settings.clickedMessage.id,
        status,
        amount,
        execDate,
        optionals.comment,
        debtorBankAccountToSend,
        optionals.isToGenerateXML,
        optionals.ImmPmtAc,
        multiplePaymentsToSend
      ).then(response => {
        if (response.status === 200) {
          switch (that.action) {
            case 'accept':
              // that.$f7.alert('Your payments will become effective on ' + execDate, 'Transaction Accepted')
              this.$f7.modal({
                title: 'Your payments will become effective on ' + execDate,
                text: '<span class="preloader"></span>'
              })
              break
            case 'modify':
              // that.$f7.alert('Your payments will become effective on ' + execDate, 'Transaction validated with modification')
              this.$f7.modal({
                title: 'Your payments will become effective on ' + execDate,
                text: '<span class="preloader"></span>'
              })
              break
            case 'refuse':
              // that.$f7.alert('', 'Transaction Revoked')
              this.$f7.modal({
                title: 'Transaction Revoked',
                text: '<span class="preloader"></span>'
              })
              break
            default:
              // that.$f7.alert('', 'Unknown Action')
              this.$f7.modal({
                title: 'Unknown Action',
                text: '<span class="preloader"></span>'
              })
          }
        }
        setTimeout(function () {
          that.$f7.closeModal()
          // loadPage(that, {url: '/contacts/', force: false, ignoreCache: false})
          that.$engine.settings.set({pendingChange: true})
          that.$engine.settings.set({inboxNormalCount: null})
          loadPage(that, {url: '/payments/inbox/'})
        }, 2000)
      })
      .catch(error => {
        errorMessageAlert(error, that)
      })
    },
    showBankAccountSelectionList ($event) {
      let that = this
      that.showIbanBox = true
      // that.$refs.ibanBox.style.display = 'block'
      // that.Dom7($event.target).next().next().css('display', 'block')
    },
    hideBankAccountSelectionList () {
      let that = this
      that.showIbanBox = false
      // that.Dom7('.bankAccountDebitSelectionListContainer').css('display', 'none')
    },
    selectBankAccount (event) {
      let that = this
      that.bankAccountSelectDebit = that.$$(event.target).parent().data('iban')
      // that.Dom7('.bankAccountDebitSelectionListContainer').css('display', 'none')
      that.showIbanBox = false
      // that.$$(event.target).parent().parent().parent().css('display', 'none')
    },
    closeSelectionListContainer () {
      let that = this
      that.showIbanBox = false
      // that.Dom7('.bankAccountDebitSelectionListContainer').css('display', 'none')
    },
    remindReceiver (id) {
      let that = this
      that.$engine.services.payments.paymentsRemind(id)
      .then(response => {
        if (response.status === 200) {
          this.$f7.modal({
            title: 'Receiver reminded',
            text: '<span class="preloader"></span>'
          })
          setTimeout(function () {
            that.$f7.closeModal()
            loadPage(that, {url: '/payments/sendbox/'})
          }, 2000)
        }
      }).catch(error => {
        errorMessageAlert(error, that)
      })
    },
    negotiateTest () {
      loadPage(this, {url: '/payments/negotiate/'})
    },
    bankCardAccept ($event) {
      let that = this
      let now = moment().format('YYYYMMDDHHmmss')
      let randomId = Math.floor(Math.random() * 900000) + 100000
      that.Dom7($event.target).next().find("input[name*='vads_trans_date']").val(now)
      that.Dom7($event.target).next().find("input[name*='vads_trans_id']").val(randomId)
      that.Dom7('#iframeTest').removeClass('hiddenElement')
      // that.Dom7('#iframeTest')[that.Dom7('#iframeTest').length - 1].removeClass('hiddenElement')
      // that.Dom7('#iframeTest')[that.Dom7('#iframeTest').length - 1].removeClass('hiddenElement')
      // that.Dom7('#iframeTest')[that.Dom7('#iframeTest').length - 1].removeClass('hiddenElement')
      // TODO: signature
      let stringToSign = 'INTERACTIVE+' + that.details.amt + '00+TEST+' + '978+' + 'PAYMENT+' + 'SINGLE+' + '63115782+' + now + '+' + randomId + '+V2+' + 'oxHbdklTjefXTrKB'
      let signature = crypto.createHash('sha1').update(stringToSign, 'utf8').digest('hex')
      that.Dom7($event.target).next().find("input[name*='signature']").val(signature.toString())
      // TODO: signature
      that.Dom7($event.target).next().submit()
      that.Dom7('.inboxDetailButton').hide()
    },
    iframeOnLoad ($event) {
      // this.ifr.iframeResizer({
      //   log: true,
      //   warningTimeout: 0,
      //   checkOrigin: false,
      //   enablePublicMethods: true,
      //   heightCalculationMethod: 'lowestElement'},
      //   this.$refs.iframeTest
      // )
    },
    hideIban (iban) {
      return formatIbanHidden(iban)
    }
  }
}
</script>
<style>
	.transaction-info {
		/* padding-top: 50px; */
		padding-left: 3%;
		padding-right: 3%;
		width: 94%;
		/* height: 100%; */
		max-height: 100%;
		clear: both;
		margin: 0 auto;
	}
	/* #attachment-info {
		margin-bottom: 3%;
	} */
	/* #decision-buttons {
		margin-top: 2%;
		width: 100%;
	} */
	/* .afterInfo {
	overflow: hidden;
	margin: 0 auto;
	clear: both;
	} */
	.modify-actions {
	}
	.changesGrid {
		border-top: 2px solid #fffdb7;
		border-bottom: 2px solid #fffdb7;
		font-weight: bold;
		text-align: center;
		background-color: #fffdb7;
	}
	.firstGridModif {
		border-top: 1px solid #E36608;
		border-bottom: 1px solid #E36608;
		font-weight: bold;
		text-align: center;
		border-radius: 0px 0px 0 0;
		margin-top: 3%;
	}
	.titleGridModif {
		color: #ffffff;
		background-color: #E36608;
		border-radius: 0px 0px 0 0;
	}
	.defaultGridDisplayModif {
		border-left: 2px solid orange;
		border-right: 2px solid orange;
		background-color: #ffffff;
	}
	.lastGridModif {
		border-bottom: 1px solid #12bcf1;
	}
  .zeroHight {
    height: 0px;
  }
  .titleGridExecuted {
    color: #ffffff;
		background-color: #46C03D;
		border-radius: 0px 0px 0 0;
  }
  .subTitlePaymentsInfo {
    color: #000000;
    /* padding: 3px 0px 9px 1%; */
    text-align: center;
    font-weight: bold;
    font-size: 16px;
  }
  .iconDetailsPage {
    font-size:15px;
    padding-left:5px;
  }
  .colorRemittanceInfomation {
    color:#144a85
  }
  .bankAccountDebitSelectionList {
    /* display: none;
    position: absolute;
    background-color: #f9f9f9; */
    margin:0px;
    /* list-style: none; */
    padding-left: 0 !important;
    max-height: 100px;
    /* overflow:hidden; */
    overflow-y:scroll;

    /* -webkit-appearance: none;
    width: 7px; */
  }
  .bankAccountDebitSelectionListContainer{
    /* display: none; */
    /* position: relative;
    right: 10px;
    top: 25px; */
    /* bottom: 0px; */
    margin-top: 1px;
    background-color: #ffffff;
    border: 1px solid #a9a9a9;
    /* min-width: 206px; */
    z-index: 20;
  }

  .bankAccountDebitSelectionInput {
    /* width: 215px; */
    font-size: 12px !important;
    height: auto !important;
    width: 190px !important;
  }
  .bankAccountDebitSelectionListItem {
    padding: 8px 8px;
  }
  .closeSelectionListContainerLabel {
    padding: 3px 8px 3px 8px;
    /* text-align: right; */
    /* height: 29px; */
    border-bottom: 1px solid #a9a9a9;
  }
  .rightButton {
    /* float: right; */
    right: 8px;
    top: 3px;
    /* width: 60px; */
    padding: 1px 5px !important;
    position: absolute;
    line-height: normal !important;
  }
  .bankAccountDebitSelectionList::-webkit-scrollbar {
      -webkit-appearance: none;
      width: 7px;
  }
  .bankAccountDebitSelectionList::-webkit-scrollbar-thumb {
      border-radius: 4px;
      background-color: rgba(0,0,0,.5);
      -webkit-box-shadow: 0 0 1px rgba(255,255,255,.5);
  }
  .closeSelectionListContainerLabelName {
    line-height: 21px;
  }
  .pain001ViewerBlock {
    display: block !important;
  }
  .pain001ViewerButtonBlock {
    margin-right: 7px !important;
    float: right !important;
    position: relative !important;
    color: #777777;
  }
  .transactionDetailFontSize {
    font-size: 14px !important;
  }
  .transactionDetailHeader{
    color:white;
    background-color: #12bcf1;
    text-align: center;
    font-size: 14px;
    display: block;
    min-height: 0 !important;
    padding: 8px 15px !important;
    /* font-weight: bold; */
  }
  .transactionDetailSubHeader {
    display: block !important;
    font-weight: bold !important;
  }
  .headerChevron {
    float: right;
    font-size: 12px;
    margin-top: 4px;
  }
</style>



// WEBPACK FOOTER //
// RequestToPayDetailPage.vue?8081a242